
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QRywcSpecGrid extends Serenity.EntityGrid<QRywcSpecRow, any> {
        // protected getColumnsKey() { return QRywcSpecColumns.columnsKey; }
        protected getDialogType() { return QRywcSpecDialog; }
        protected getIdProperty() { return QRywcSpecRow.idProperty; }
        protected getInsertPermission() { return QRywcSpecRow.insertPermission; }
        protected getLocalTextPrefix() { return QRywcSpecRow.localTextPrefix; }
        protected getService() { return QRywcSpecService.baseUrl; }

        // constructor(container: JQuery) {
        //     super(container);
        // }
    }
}